import { observable, action, runInAction, computed, makeObservable } from "mobx";
import { API } from "General/API";
import { projectsDataStore } from "Stores/ProjectsStore";
import { CoreStore } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";

interface EmailUnread {
  unreadPrivate: number;
  unreadProject: number;
}

class EmailUnreadStore extends CoreStore {
  data: EmailUnread;

  url() {
    return "";
  }

  clear() {
    this.data = undefined;
  }

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      fetch: action.bound,
      markRead: action.bound,
      unreadPrivate: computed,
      unreadProject: computed,
    });

    this.reset();
  }

  reset() {
    this.data = { unreadPrivate: 0, unreadProject: 0 };
  }

  async fetch() {
    try {
      const response: EmailUnread = await API.getData(API_URL.MAILS.unread(projectsDataStore.projectId));
      runInAction(() => {
        this.data = response;
      });
    } catch (err) {
      throw err;
    }
  }

  markRead(type: "project" | "private") {
    if (type === "project") {
      if (this.data.unreadProject > 0) {
        this.data.unreadProject = this.data.unreadProject - 1;
      }
    } else if (type === "private") {
      if (this.data.unreadPrivate > 0) {
        this.data.unreadPrivate = this.data.unreadPrivate - 1;
      }
    }
  }

  get unreadPrivate() {
    return this.data.unreadPrivate;
  }

  get unreadProject() {
    return this.data.unreadProject;
  }
}

const emailUnreadStore = new EmailUnreadStore();

export { emailUnreadStore, EmailUnreadStore };
